import { render } from "./AppFooter.vue?vue&type=template&id=2e3b7f54"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\info\\OneDrive\\Desktop\\REPO_MARTECH\\rcstudio-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__